import React, { Component } from 'react';

import { updateLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import { browserHistory } from 'react-router';

import * as ByesignHelper from 'components/byesign/ByesignHelper';
import LanguageDropDown from '../../navigation/LanguageDropDown';

import * as documentPortalActions from 'actions/documentPortalActions';
import LandlordLogo from 'components/shared/LandlordLogo';

let NavBar = connect(
  store => {
    return {
      brandingLogo: store.documentPortal.brandingLogo,
    };
  },
  dispatch => {
    return {
      updateLanguage: value => {
        dispatch(updateLanguage(value));
      },
      getBrandingLogo: document_uuid => {
        dispatch(documentPortalActions.getBrandingLogo(document_uuid));
      },
    };
  }
)(
  class NavBar extends Component {
    UNSAFE_componentWillMount = () => {
      const query = browserHistory.getCurrentLocation().query;
      this.props.getBrandingLogo(query.document_uuid);
    };

    handleLanguageChange = value => {
      this.props.updateLanguage(value);
    };

    render() {
      const style = {
        dropDown: {
          fontSize: '12px',
          color: '#3e3e3e',
          width: '110px',
          marginRight: '-25px',
          marginLeft: '5px',
        },
      };

      return (
        <div className="nav-bar" style={{ position: 'fixed', width: '100%' }}>
          <header className="global-header-view">
            <nav>
              <div className="navigation-canvas">
                <div>
                  <div className="global-header-left">
                    <div
                      style={{
                        width: '89px',
                        display: 'inline-flex',
                        height: '40px',
                      }}
                    >
                      <div className="global-header-item-container">
                        <span className="global-header-left global-header-item">
                          {this.props.brandingLogo !== ByesignHelper.constants.DEFAULT_LOGO &&
                            this.props.brandingLogo !== null && (
                              <div className="mobile-app-logo" style={{ marginTop: '6px' }}>
                                <img
                                  style={{ height: '40px' }}
                                  src={this.props.brandingLogo}
                                  alt="yuhu"
                                />
                              </div>
                            )}
                          {this.props.brandingLogo === ByesignHelper.constants.DEFAULT_LOGO &&
                            this.props.brandingLogo !== null && (
                              <div
                                className="row"
                                style={{
                                  width: '116px',
                                  float: 'left',
                                  marginTop: '-1px',
                                  marginLeft: '8px',
                                }}
                              >
                                <LandlordLogo maxWidth="137px" height="46px" textHeight="30px" />
                              </div>
                            )}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'inline',
                        width: 'calc(100% - 89px)',
                        float: 'right',
                        height: '40px',
                        padding: '20px 15px 0px 20px',
                        marginTop: '-16px',
                      }}
                    >
                      <div style={{ float: 'right' }}>
                        <LanguageDropDown
                          style={style.dropDown}
                          handleLanguageChange={this.handleLanguageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </header>
        </div>
      );
    }
  }
);

export default localize()(NavBar);
